import { TFunction } from 'i18next';
import {
	TrendsTypes,
	SatisfactionLevelTypes,
} from 'modules/admin-panel/pages/results/models';

export function getRateTypeList(
	rateTypes: typeof SatisfactionLevelTypes | typeof TrendsTypes,
	t: TFunction,
	tKey: string,
) {
	return Object.values(rateTypes).map((type) => ({
		title: t(`${tKey}${type}`),
		value: type,
	}));
}
